/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_GenericInputs */

const en_conversion_error_generic = /** @type {(inputs: Conversion_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your document could not be converted.`)
};

const es_conversion_error_generic = /** @type {(inputs: Conversion_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo convertir tu documento.`)
};

/**
* | output |
* | --- |
* | "Your document could not be converted." |
*
* @param {Conversion_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_generic = /** @type {((inputs?: Conversion_Error_GenericInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_GenericInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_generic(inputs)
	return en_conversion_error_generic(inputs)
});